import InfoRoute from './ArchiveRoute';
import ArchiveLink from './ArchiveLink';

export default InfoRoute;
export { ArchiveLink };
